import type { FC } from 'react';
import { memo } from 'react';

import { GainAccessView } from '../../components/GainAccessView';
import type { CompanyOverviewProps } from '../../domain/company';

import { CompanyOverview } from './CompanyOverview';
import useCompanyQuotaCheck from './useCompanyQuotaCheck';

const CompanyOverviewContainerComponent: FC<CompanyOverviewProps> = ({
  variant: companyOverviewVariant,
  onScrollToTop,
}) => {
  const { variant, isQuotaReached } = useCompanyQuotaCheck();

  if (isQuotaReached) {
    return <GainAccessView variant={variant} />;
  }

  return <CompanyOverview variant={companyOverviewVariant} onScrollToTop={onScrollToTop} />;
};

export const CompanyOverviewContainer = memo(CompanyOverviewContainerComponent);
